var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"construction_top flex flex_between"},[_c('div',{staticClass:"addConstruction flex"},[_c('button',{staticClass:"btn_primary",on:{"click":function($event){return _vm.goAdd(`${_vm.is_role}_applyEngineering`)}}},[_vm._v(" 申請工程單 ")])])]),_c('EngineeringList',{attrs:{"pageRole":"department"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }